export const companySyncFieldOptions = [
  {
    value: 'lastSettingsSync',
    label: 'Settings sync cache',
    description:
      'Use this when you want the next sync to re-read Intacct settings immediately, including EE preferences such as ENABLEALLOCATIONS.',
  },
  {
    value: 'lastBackupSync',
    label: 'Backup sync cursor',
    description:
      'Use this when backup-based objects look stale and you want the next backup sync window to be rebuilt from scratch.',
  },
  {
    value: 'syncStart',
    label: 'Last sync start',
    description:
      'Use this to clear the recorded sync start time when you want the admin UI to stop showing an old or misleading start marker.',
  },
  {
    value: 'syncEnd',
    label: 'Last sync completion',
    description:
      'Use this to clear the recorded completion time when you want the admin UI to stop showing an old “last synced” value.',
  },
] as const;

export type CompanySyncField =
  (typeof companySyncFieldOptions)[number]['value'];
